import Login from './components/Auth/Login';
import Home from './components/Admin/home';
import EndUserList from './components/Admin/Users/list';
import EndUserDetails from './components/Admin/Users/details';
import EndUserForm from './components/Admin/Users/form';
import WorkflowList from './components/Admin/Workflows/list';
import WorkflowVersionsList from './components/Admin/Workflows/versions';
import MainWizard from './components/Admin/Workflows/Wizard/main_wizard';
import WorkflowViewer from './components/Admin/Workflows/Wizard/workflowViewer';
import FormCreate from './components/Admin/Forms/create';
import FormList from './components/Admin/Forms/list';
import FormDetails from './components/Admin/Forms/details';
import FormUpdate from './components/Admin/Forms/update';
import SubFormCreate from './components/Admin/SubForms/create';
import SubFormList from './components/Admin/SubForms/list';
import SubFormDetails from './components/Admin/SubForms/details';
import SubFormEdit from './components/Admin/SubForms/update';
import Approvals from './components/Admin/Approvals/Approvals';
import FormApprove from './components/Admin/Approvals/FormApprove';
import CategoriesWithReload from './components/Admin/Category/list';
import CategoryForm from './components/Admin/Category/form'
import UserCategory from './components/Admin/Category/users'

import UserList from './components/Super_Admin/Users/list';
import UserDetails from './components/Super_Admin/Users/details';
import UserForm from './components/Super_Admin/Users/form';
import RoleList from './components/Super_Admin/Roles/list';
import RoleUsersList from "./components/Super_Admin/Roles/usersList";
import RoleForm from './components/Super_Admin/Roles/form';
import Logs from './components/Super_Admin/Logs/logs';
import SuperAdminHome from './components/Super_Admin/home';
import LogDetails from './components/Super_Admin/Logs/LogDetails';

import CustomerHome from './components/Guest/home';
import FormRenderer from './components/Guest/Workflows/subForm';
import MyRequests from './components/Guest/Requests/My_Requests/list';
import MyRequestDetails from './components/Guest/Requests/My_Requests/MyRequestDetails';
import NewRequests from './components/Guest/Requests/New_Requests/list';
import NewRequestDetails from './components/Guest/Requests/New_Requests/details';
import CustomerRegister from './components/Auth/Register';

import RemdinerForm from './components/Sla_Reminders/form'
import { ErrorPage } from './components/error/ErrorPage';
import CommitteeReviewsList from './components/Guest/Committee/reviews_list';
import ReviewDetails from './components/Guest/Committee/ReviewDetails';
import CoreValidatorList from './components/Admin/Approvals/CoreValidator/CoreValidator';
import XMLViewerPage from './components/common/XMLViewer/XMLViewerPage';

// product details and manufacturer sites
import ProductDetailsList from './components/Guest/Products/ProductDetailsList';
import ProductDetailsDetails from './components/Guest/Products/ProductDetailsDetails';
import ManufacturerSiteList from './components/Guest/Manufacturers/ManufacturerSiteList';
import ManufacturerSiteDetails from './components/Guest/Manufacturers/ManufacturerSiteDetails';
import AdminProductDetailsList from './components/Admin/Products/ProductDetailsList';
import AdminProductDetailsDetails from './components/Admin/Products/ProductDetailsDetails';
import AdminManufacturerSiteList from './components/Admin/Manufacturers/ManufacturerSiteList';
import AdminManufacturerSiteDetails from './components/Admin/Manufacturers/ManufacturerSiteDetails';
import { PaymentProcessing } from './components/Payment';

// ADMIN ROUTES
export const adminRoutesConfig = [
  { path: '/admin/requests', title: 'Requests', element: Approvals },
  { path: '/admin/categories', title: 'Categories', element: CategoriesWithReload },
  { path: '/admin/categories/create', title: 'Create Category', element: CategoryForm },
  { path: '/admin/categories/edit/:id', title: 'Edit Category', element: CategoryForm },
  { path: '/admin/categories/:id/:categoryName-users', title: 'User Category', element: UserCategory },
  { path: '/admin/end-users', title: 'End Users', element: EndUserList },
  { path: '/admin/end-users/create', title: 'Create End User', element: EndUserForm },
  { path: '/admin/end-users/details/:id', title: 'End User Details', element: EndUserDetails },
  { path: '/admin/end-users/edit/:id', title: 'Edit End User', element: EndUserForm },
  { path: '/admin/forms', title: 'Forms', element: FormList },
  { path: '/admin/forms/create', title: 'Create Form', element: FormCreate },
  { path: '/admin/forms/details/:id', title: 'Form Details', element: FormDetails },
  { path: '/admin/forms/edit/:id', title: 'Edit Form', element: FormUpdate },
  { path: '/admin/home', title: 'Homepage', element: Home },
  { path: '/admin', title: 'Homepage', element: Home },
  { path: '/admin/logs/:resource', title: 'Logs', element: Logs },
  { path: '/admin/logs/:resource/log/:id', title: 'Log Details', element: LogDetails },
  { path: '/admin/reminders', title: 'Reminders', element: RemdinerForm },
  { path: '/admin/requests/details/:id', title: 'Review Form', element: FormApprove, extraProps: { persona: 'admin' } },
  { path: '/admin/roles', title: 'Roles', element: RoleList },
  { path: '/admin/roles/create', title: 'Create Role', element: RoleForm, extraProps: { caseProp: "role" } },
  { path: '/admin/roles/edit/:id', title: 'Edit Role', element: RoleForm, extraProps: { caseProp: "role" } },
  { path: '/admin/subforms', title: 'SubForms', element: SubFormList },
  { path: '/admin/subforms/create', title: 'Create SubForm', element: SubFormCreate },
  { path: '/admin/subforms/details/:id', title: 'SubForm Details', element: SubFormDetails },
  { path: '/admin/subforms/edit/:id', title: 'Edit SubForm', element: SubFormEdit },
  { path: '/admin/user/privilegis/:id', title: 'User Privileges', element: RoleForm, extraProps: { caseProp: "user" } },
  { path: '/admin/users', title: 'Users', element: UserList },
  { path: '/admin/users/create', title: 'Create User', element: UserForm },
  { path: '/admin/users/details/:id', title: 'User Details', element: UserDetails },
  { path: '/admin/users/edit/:id', title: 'Edit User', element: UserForm },
  { path: '/admin/workflows', title: 'Workflows', element: WorkflowList },
  { path: '/admin/workflows/create', title: 'Create Workflow', element: MainWizard },
  { path: '/admin/workflows/draft/:draftId', title: 'Edit Workflow Draft', element: MainWizard },
  { path: '/admin/workflows/:wfId/versions', title: 'Workflow Versions', element: WorkflowVersionsList },
  { path: '/admin/workflows/:wfId/versions/create', title: 'Create Workflow Version', element: MainWizard },
  { path: '/admin/workflows/:wfId/versions/:vId/view', title: 'View Workflow Version', element: WorkflowViewer },
  { path: '/admin/workflows/:wfId/versions/:vId', title: 'Edit Workflow Version', element: MainWizard },
  { path: '/admin/core-validator/:request_progress_id', title: 'Core Validator', element: CoreValidatorList },
  { path: '/admin/product-details', title: 'Product Details', element: AdminProductDetailsList },
  { path: '/admin/product-details/details/:id', title: 'Product Details', element: AdminProductDetailsDetails },
  { path: '/admin/manufacturers-site', title: 'Manufacturers Site', element: AdminManufacturerSiteList },
  { path: '/admin/manufacturers-site/details/:id', title: 'Manufacturer Site Details', element: AdminManufacturerSiteDetails },
  
];

// SUPER ADMIN ROUTES
export const superAdminRoutesConfig = [
  { path: '/super-admin/approvals', title: 'Approvals', element: Approvals },
  { path: '/super-admin/categories', title: 'Categories', element: CategoriesWithReload },
  { path: '/super-admin/categories/create', title: 'Create Category', element: CategoryForm },
  { path: '/super-admin/categories/edit/:id', title: 'Edit Category', element: CategoryForm },
  { path: '/super-admin/categories/:id/:categoryName-users', title: 'User Category', element: UserCategory },
  { path: '/super-admin/end-users', title: 'End Users', element: EndUserList },
  { path: '/super-admin/end-users/create', title: 'Create End User', element: EndUserForm },
  { path: '/super-admin/end-users/details/:id', title: 'End User Details', element: EndUserDetails },
  { path: '/super-admin/end-users/edit/:id', title: 'Edit End User', element: EndUserForm },
  { path: '/super-admin/forms', title: 'Forms', element: FormList },
  { path: '/super-admin/forms/create', title: 'Create Form', element: FormCreate },
  { path: '/super-admin/forms/details/:id', title: 'Form Details', element: FormDetails },
  { path: '/super-admin/forms/edit/:id', title: 'Edit Form', element: FormUpdate },
  { path: '/super-admin/home', title: 'Homepage', element: SuperAdminHome },
  { path: '/super-admin', title: 'Homepage', element: SuperAdminHome },
  { path: '/super-admin/logs/:resource', title: 'Logs', element: Logs },
  { path: '/super-admin/logs/:resource/log/:id', title: 'Log Details', element: LogDetails },
  { path: '/super-admin/reminders', title: 'Reminders', element: RemdinerForm },
  { path: '/super-admin/review/:id', title: 'Review Form', element: FormApprove, extraProps: { persona: 'admin' } },
  { path: '/super-admin/roles', title: 'Roles', element: RoleList },
  { path: '/super-admin/roles/create', title: 'Create Role', element: RoleForm, extraProps: { caseProp: "role" } },
  { path: '/super-admin/roles/details/:id', title: 'Role Users', element: RoleUsersList },
  { path: '/super-admin/roles/edit/:id', title: 'Edit Role', element: RoleForm, extraProps: { caseProp: "role" } },
  { path: '/super-admin/subforms', title: 'SubForms', element: SubFormList },
  { path: '/super-admin/subforms/create', title: 'Create SubForm', element: SubFormCreate },
  { path: '/super-admin/subforms/details/:id', title: 'SubForm Details', element: SubFormDetails },
  { path: '/super-admin/subforms/edit/:id', title: 'Edit SubForm', element: SubFormEdit },
  { path: '/super-admin/user/privilegis/:id', title: 'User Privileges', element: RoleForm, extraProps: { caseProp: "user" } },
  { path: '/super-admin/users', title: 'Users', element: UserList },
  { path: '/super-admin/users/create', title: 'Create User', element: UserForm },
  { path: '/super-admin/users/details/:id', title: 'User Details', element: UserDetails },
  { path: '/super-admin/users/edit/:id', title: 'Edit User', element: UserForm },
  { path: '/super-admin/workflows', title: 'Workflows', element: WorkflowList },
  { path: '/super-admin/workflows/create', title: 'Create Workflow', element: MainWizard },
  { path: '/super-admin/workflows/draft/:draftId', title: 'Edit Workflow Draft', element: MainWizard },
  { path: '/super-admin/workflows/:wfId/versions', title: 'Workflow Versions', element: WorkflowVersionsList },
  { path: '/super-admin/workflows/:wfId/versions/create', title: 'Create Workflow Version', element: MainWizard },
  { path: '/super-admin/workflows/:wfId/versions/:vId/view', title: 'View Workflow Version', element: WorkflowViewer },
  { path: '/super-admin/workflows/:wfId/versions/:vId', title: 'Edit Workflow Version', element: MainWizard },
  { path: '/super-admin/product-details', title: 'Product Details', element: AdminProductDetailsList },
  { path: '/super-admin/product-details/details/:id', title: 'Product Details', element: AdminProductDetailsDetails },
  { path: '/super-admin/manufacturers-site', title: 'Manufacturers Site', element: AdminManufacturerSiteList },
  { path: '/super-admin/manufacturers-site/details/:id', title: 'Manufacturer Site Details', element: AdminManufacturerSiteDetails },
];

// CUSTOMER ROUTES
export const customerRoutesConfig = [
  { path: '/customer/home', title: 'Homepage', element: CustomerHome },
  { path: '/customer/subform', title: 'SubForm', element: FormRenderer },
  { path: '/customer/requests/my-requests', title: 'My Requests', element: MyRequests },
  { path: '/customer/requests/my-requests/details/:id', title: 'My Requests Details', element: MyRequestDetails, extraProps: { persona: 'customer' } },
  { path: '/customer/requests/my-requests/send-back/:id', title: 'Send Back', element: NewRequestDetails },
  { path: '/customer/requests/new-requests/view/:id', title: 'New Request Details', element: NewRequestDetails },
  { path: '/customer/requests/new-requests', title: 'New Request', element: NewRequests },

  {path: '/customer/assessment-review', title: 'Requests', element: CommitteeReviewsList },
  { path: '/customer/assessment-review/details/:id', title: 'Review Details', element: FormApprove, extraProps: { persona: 'customer' } },
  { path: '/customer/assessment-review/review-details/details/:id', title: 'Review Details', element: ReviewDetails, extraProps: { persona: 'customer' } },
  { path: '/customer/product-details', title: 'Product Details', element: ProductDetailsList },
  { path: '/customer/product-details/details/:id', title: 'Product Details', element: ProductDetailsDetails },
  { path: '/customer/manufacturers-site', title: 'Manufacturers Site', element: ManufacturerSiteList },
  { path: '/customer/manufacturers-site/details/:id', title: 'Manufacturer Site Details', element: ManufacturerSiteDetails },

];

// PUBLIC & ERROR ROUTES
export const publicRoutesConfig = [
  { path: '/', title: 'Login', element: Login },
  { path: '/login', title: 'Login', element: Login },
  { path: '/customer/register', title: 'Registeration', element: CustomerRegister },
  { path: '/xml-viewer', title: 'XML Viewer', element: XMLViewerPage },
  { path: '/payment/processing', title: 'Payment Processing', element: PaymentProcessing },
  { path: '/error/404', title: '404 Not Found', element: ErrorPage, extraProps: { statusCode: 404 } },
  { path: '/error/403', title: '403 Forbidden', element: ErrorPage, extraProps: { statusCode: 403 } },
  { path: '/error/500', title: '500 Server Error', element: ErrorPage, extraProps: { statusCode: 500 } },
  { path: '*', title: '404 Not Found', element: ErrorPage, extraProps: { statusCode: 404 } },
];